import { useSearchParams } from "react-router-dom";
import { PageHero } from "@/components/common";
import VenueMap from "@/components/VenueMap";
import useTitle from "@/lib/useTitle";

export default function Mapa() {
  useTitle("Mapa do recinto");
  const [params] = useSearchParams();
  return (
    <>
      <PageHero eyebrow="Jardim Botânico da Ajuda" title="Mapa do recinto" tone="#0f766e" image="/img/garden.jpg">Encontre palcos, oficinas, rastreios, expositores, pontos de informação e de apoio, zonas de descanso e acessos adaptados.</PageHero>
      <div className="container-x py-10"><VenueMap initial={params.get("espaco")} /></div>
    </>
  );
}
